import React, { useState } from "react";
import useApi from "../../hooks/useApi";

const MarketedForm = ({ onSave }) => {
  const api = useApi();
  const [name, setName] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const res = await api.post("productAdditionalInfo/marketed-bys", { name });
      onSave(res.data || { name });
      setName("");
    } catch (err) {
      setError("Failed to create marketer.");
    }
    setLoading(false);
  };

  return (
    <form onSubmit={handleSubmit} className="flex items-center space-x-2">
      <input
        type="text"
        value={name}
        onChange={e => setName(e.target.value)}
        placeholder="New Marketer"
        className="border rounded p-2"
        required
      />
      <button type="submit" disabled={loading} className="bg-green-600 text-white px-3 py-2 rounded">
        {loading ? "Adding..." : "Add"}
      </button>
      {error && <span className="text-red-600 ml-2">{error}</span>}
    </form>
  );
};

export default MarketedForm;